export type SupportContactKind = 'whatsapp' | 'telegram' | 'link'

export type SupportContact = {
  kind?: SupportContactKind | string | null
  whatsapp?: string | null
  telegram?: string | null
  link?: string | null
} | null | undefined

function formatWhatsappHref(value: string): string | null {
  const digits = value.replace(/\D/g, '')
  if (!digits) return null
  return `https://wa.me/${digits}`
}

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

export function resolveSupportContactHref(contact: SupportContact): string | null {
  if (!contact?.kind) return null

  switch (contact.kind) {
    case 'whatsapp':
      return isNonEmptyString(contact.whatsapp)
        ? formatWhatsappHref(contact.whatsapp)
        : null
    case 'telegram':
      return isNonEmptyString(contact.telegram) ? contact.telegram.trim() : null
    case 'link':
      return isNonEmptyString(contact.link) ? contact.link.trim() : null
    default:
      return null
  }
}
